export default {
  setCustomers(state, value) {
    state.customers = value
  },
  setCustomerFilters(state, filters) {
    state.customerFilters = filters
  },
  setCustomersCounter(state, counter) {
    state.customersCounter = counter
  },
  setCustomerErrors(state, serviceErrors) {
    state.customerErrors = serviceErrors
  },
  setCustomer(state, value) {
    state.customer = value
  },
  setCustomerField(state, { key, value }) {
    if (state.customer) {
      state.customer[key] = value
    }
  },
  setCustomerLogs(state, data) {
    state.customerLogs = data
  },
  setCustomerVisits(state, data) {
    state.customerVisits = data
  },
  setCustomerBookings(state, data) {
    state.customerBookings = data
  },
  setCustomerSipHistory(state, data) {
    state.customerSipHistory = data
  },
  deleteCustomer(state, id) {
    for (let i = 0; i < state.customers.length; i++) {
      if (state.customers[i].id === id) {
        state.customers.splice(i, 1)
        break
      }
    }
  },
  changeCustomer(state, payload) {
    for (let i = 0; i < state.customers.length; i++) {
      if (state.customers[i].id === payload.key) {
        state.customers.splice(i, 1, payload.value)
        break
      }
    }
  },
  unshiftCustomers(state, customer) {
    state.customers.unshift(customer)
  },
}
